export default __webpack_public_path__ + "static/media/telefonovector.d5dbe3c7.svg";